/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmExecuteAutomationDocumentRequest extends models.AwsSsmBaseExecuteDocumentRequest {
    getFixupPrototypeFunction() { return AwsSsmExecuteAutomationDocumentRequest.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmExecuteAutomationDocumentRequest>): AwsSsmExecuteAutomationDocumentRequest {
        let obj = Object.assign(new AwsSsmExecuteAutomationDocumentRequest(), model);
        AwsSsmExecuteAutomationDocumentRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmExecuteAutomationDocumentRequest>): AwsSsmExecuteAutomationDocumentRequest {
        if (!model) return null;
        return AwsSsmExecuteAutomationDocumentRequest.newInstance(<AwsSsmExecuteAutomationDocumentRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmExecuteAutomationDocumentRequest) {
        if (!obj) return;

        models.AwsSsmExecuteAutomationDocumentRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmExecuteAutomationDocumentRequest): boolean {
        if (models.AwsSsmBaseExecuteDocumentRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AwsSsmExecuteAutomationDocumentRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.targets) {
            for (let val of this.targets) {
                models.AwsSsmCommandDocumentTarget.fixupPrototype(val);
            }
        }
        if (this.target_locations) {
            for (let val of this.target_locations) {
                models.AwsSsmExecuteAutomationTargetLocation.fixupPrototype(val);
            }
        }
        if (this.tags) {
            for (let val of this.tags) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * Client auth token.
     */
    client_token: string;

    /**
     * Execution mode of the document.
     */
    mode: string;

    /**
     * The name of the parameter used as the target resource for the rate-controlled execution.
     */
    target_parameter_name: string;

    /**
     * An array of search criteria that targets managed nodes using a Key,Value combination.
     */
    targets: Array<models.AwsSsmCommandDocumentTarget>;

    /**
     * A key-value mapping of document parameters to target resources.
     */
    target_maps: { [key: string]: Array<string>; };

    /**
     * A location is a combination of AWS Regions and/or AWS accounts.
     */
    target_locations: Array<models.AwsSsmExecuteAutomationTargetLocation>;

    /**
     * List of tag key/value pairs
     */
    tags: Array<models.KeyValuePair>;

}
